if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        if (this.modalContent) this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay-spinner').classList.remove('hidden');

        const productUrl = opener.getAttribute('data-product-url');
        const variantId = this.getVariantIdForQuickAdd(opener);
        const requestUrl = this.buildProductUrlWithVariant(productUrl, variantId);

        fetch(requestUrl)
          .then(response => response.text())
          .then(responseText => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            if (!this.productElement) {
              if (productUrl) window.location.assign(productUrl);
              return;
            }
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            this.disableUrlUpdates();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();
            super.show(opener);
            requestAnimationFrame(() => {
              const galleries = this.modalContent?.querySelectorAll('media-gallery') || [];
              galleries.forEach(gallery => {
                if (typeof gallery.refresh === 'function') gallery.refresh();
              });

              const sliders = this.modalContent?.querySelectorAll('slider-component') || [];
              sliders.forEach(slider => {
                if (typeof slider.initPages === 'function') slider.initPages();
                if (typeof slider.update === 'function') slider.update();
              });
            });
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay-spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Re-execute any scripts contained in the injected HTML
        const scriptElements = element.querySelectorAll('script');
        scriptElements.forEach(oldScript => {
          const src = oldScript.getAttribute('src');
          // Skip duplicate external scripts
          if (src) {
            const existingScriptCount = document.querySelectorAll(`script[src="${src}"]`).length;
            if (existingScriptCount > 1) return;
          }

          const newScript = document.createElement('script');

          // Copy all attributes (src, type, async, etc.)
          for (const { name, value } of Array.from(oldScript.attributes)) {
            newScript.setAttribute(name, value);
          }

          // Copy inline script content, if any
          if (oldScript.textContent) {
            newScript.textContent = oldScript.textContent;
          }

          // Replace the old script so the browser executes the new one
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }

      preventVariantURLSwitching() {
        const variantSwitcher = this.modalContent.querySelector('variant-radios,variant-selects');
        if (variantSwitcher) variantSwitcher.setAttribute('data-update-url', 'false');
      }

      disableUrlUpdates() {
        this.modalContent.querySelectorAll('product-info').forEach(productInfo => {
          productInfo.dataset.updateUrl = 'false';
        });
      }

      removeDOMElements() {
        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
          sectionId,
          `quickadd-${sectionId}`
        );
        this.productElement.querySelectorAll('product-info').forEach(productInfo => {
          productInfo.dataset.originalSection = sectionId;
        });
        this.productElement
          .querySelectorAll('variant-selects, variant-radios')
          .forEach(variantSelect => {
            variantSelect.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach(li => li.setAttribute('role', 'presentation'));
      }

      buildProductUrlWithVariant(productUrl, variantId) {
        if (!variantId || !productUrl) return productUrl;

        try {
          const url = new URL(productUrl, window.location.origin);
          url.searchParams.set('variant', variantId);
          return url.toString();
        } catch (error) {
          const separator = productUrl.includes('?') ? '&' : '?';
          return `${productUrl}${separator}variant=${variantId}`;
        }
      }

      getVariantIdForQuickAdd(opener) {
        const card =
          opener.closest('.card-wrapper') ||
          opener.closest('.card') ||
          opener.closest('.product-card');
        const activeSwatch = card?.querySelector('color-swatches .variant-swatch-toggle.active');

        if (activeSwatch) {
          const variantLink = activeSwatch.getAttribute('data-variant-link');
          if (variantLink) {
            try {
              const url = new URL(variantLink, window.location.origin);
              const variantId = url.searchParams.get('variant');
              if (variantId) return variantId;
            } catch (error) {
              // Fall through to other sources
            }
          }
        }

        const productLink = card?.querySelector('.product-card-link');
        if (productLink?.href) {
          try {
            const url = new URL(productLink.href, window.location.origin);
            const variantId = url.searchParams.get('variant');
            if (variantId) return variantId;
          } catch (error) {
            // Fall through to opener dataset
          }
        }

        return opener.getAttribute('data-variant-id');
      }
    }
  );
}
